export default __webpack_public_path__ + "static/media/ic_manage-sim.91c5a1dd.svg";